import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Smiley from './Smiley.jsx';
import { ChevronDown, WhatsAppGlyph } from './Icons.jsx';
import { SERVICES } from '../data/services-nav.js';
import { WA_URL } from '../config.js';
import { trackWhatsApp } from '../analytics.js';

export default function Header() {
  const { pathname } = useLocation();
  const [drop, setDrop] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const dropRef = useRef(null);

  useEffect(() => {
    function onClick(e) {
      if (dropRef.current && !dropRef.current.contains(e.target)) setDrop(false);
    }
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobile(false); setDrop(false); }, [pathname]);

  const isService = pathname === '/services' || pathname.startsWith('/services/');
  const isBlog = pathname === '/blog' || pathname.startsWith('/blog/');

  return (
    <header className={'hdr' + (scrolled ? ' is-scrolled' : '')}>
      <div className="wrap hdr-inner">
        <Link to="/" className="brand-mark" aria-label="FocusMode -- דף הבית" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <span className="smy"><Smiley size={32} /></span>
          <span>FocusMode</span>
        </Link>
        <nav className={'nav' + (mobile ? ' is-mobile-open' : '')} aria-label="ראשי">
          <div className={'dropdown' + (drop ? ' open' : '')} ref={dropRef}>
            <Link
              to="/services"
              className={'dropdown-trigger' + (isService ? ' is-active' : '') + (drop ? ' is-open' : '')}
              onClick={(e) => { e.preventDefault(); setDrop(v => !v); }}
            >
              שירותים <ChevronDown />
            </Link>
            <div className="dropdown-menu" role="menu">
              {SERVICES.map(s => (
                <Link key={s.slug} to={`/services/${s.slug}`} role="menuitem">
                  <strong>{s.title}</strong>
                  <span>{s.short}</span>
                </Link>
              ))}
            </div>
          </div>
          <Link to="/about" className={pathname === '/about' ? 'is-active' : ''}>אודות</Link>
          <Link to="/blog" className={isBlog ? 'is-active' : ''}>בלוג</Link>
          <Link to="/contact" className={pathname === '/contact' ? 'is-active' : ''}>יצירת קשר</Link>
        </nav>
        <div className="hdr-actions">
          <a
            className="hdr-wa"
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="שיחת WhatsApp"
            onClick={() => trackWhatsApp('header')}
          >
            <WhatsAppGlyph size={18} />
            <span>WhatsApp</span>
          </a>
          <button className="menu-btn" aria-label="תפריט" aria-expanded={mobile} onClick={() => setMobile(v => { if (v) setDrop(false); return !v; })}>
            {mobile ? (
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="6" y1="6" x2="18" y2="18" />
                <line x1="18" y1="6" x2="6" y2="18" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
